function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M13.414 12l7.293-7.293c.391-.39.391-1.023 0-1.414-.39-.39-1.023-.39-1.414 0L12 10.586 4.707 3.293c-.39-.39-1.023-.39-1.414 0-.39.391-.39 1.023 0 1.414L10.586 12l-7.293 7.293c-.39.391-.39 1.023 0 1.414.195.195.451.293.707.293.256 0 .512-.098.707-.293L12 13.414l7.293 7.293c.195.195.451.293.707.293.256 0 .512-.098.707-.293.391-.39.391-1.023 0-1.414L13.414 12z",
  transform: "translate(-1516 -171) translate(1504 159) translate(12 12)"
})))));

function SvgIconClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iY3VycmVudENvbG9yIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTMuNDE0IDEybDcuMjkzLTcuMjkzYy4zOTEtLjM5LjM5MS0xLjAyMyAwLTEuNDE0LS4zOS0uMzktMS4wMjMtLjM5LTEuNDE0IDBMMTIgMTAuNTg2IDQuNzA3IDMuMjkzYy0uMzktLjM5LTEuMDIzLS4zOS0xLjQxNCAwLS4zOS4zOTEtLjM5IDEuMDIzIDAgMS40MTRMMTAuNTg2IDEybC03LjI5MyA3LjI5M2MtLjM5LjM5MS0uMzkgMS4wMjMgMCAxLjQxNC4xOTUuMTk1LjQ1MS4yOTMuNzA3LjI5My4yNTYgMCAuNTEyLS4wOTguNzA3LS4yOTNMMTIgMTMuNDE0bDcuMjkzIDcuMjkzYy4xOTUuMTk1LjQ1MS4yOTMuNzA3LjI5My4yNTYgMCAuNTEyLS4wOTguNzA3LS4yOTMuMzkxLS4zOS4zOTEtMS4wMjMgMC0xLjQxNEwxMy40MTQgMTJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTUxNiAtMTcxKSB0cmFuc2xhdGUoMTUwNCAxNTkpIHRyYW5zbGF0ZSgxMiAxMikiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cgo=";
export { ForwardRef as ReactComponent };